<script>
    import SelectToken from "../form/SelectToken.svelte";
    import {Button, Col, Container, Row} from "@sveltestrap/sveltestrap";
    import {csAvailableSupported, currentPage, eventBridge, loginPin, loginToken, portalConfiguration} from "../../stores.js";
    import LoginPin from "./LoginPin.svelte";
    import LoginToken from "./LoginToken.svelte";
    import ConfirmModal from "../modal/ConfirmModal.svelte";
    import Fa from "svelte-fa";
    import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
    import {onMount} from "svelte";

    let showErrorWithRedirect = $state(false);
    let errorTitle = $state(), errorMessage = $state();

    function handleKeycloakError(event) {
        errorTitle = "Fehler";
        errorMessage = "Das Zertifikat ist nicht gültig oder die Gültigkeit des Zertifikats konnte nicht erfolgreich online geprüft werden.";
        showErrorWithRedirect = true;
    }

    function focusLoginButton() {
        const loginButton = document.getElementById('loginTokenLoginButton');
        if (loginButton && !loginButton.hasAttribute('disabled')) {
            loginButton.focus();
        }
    }

    onMount(() => {
        $loginPin = '';
        const handleMessage = (event) => {
            if (event.detail.messageCode === 'SSO_LOGIN_EXCEPTION') {
                handleKeycloakError(event);
            }
        };

        $eventBridge.addEventListener('kc:message', handleMessage);

        return () => {
            $eventBridge.removeEventListener('kc:message', handleMessage);
        };
    });
    let isValid = $derived($loginToken?.state === "AVAILABLE" && $csAvailableSupported);

    $effect(() => {
        if ($loginToken && isValid) {
            setTimeout(focusLoginButton, 0);
        }
    });

    $effect(() => {
        if (!!$portalConfiguration?.beaLogin) {
            window.history.replaceState({}, '', $portalConfiguration.beaLogin);
        }
    });
</script>

<h1>Anmeldung</h1>

<h2>Melden Sie sich mit Ihren beA-Zugangsdaten an</h2>

<Container>
    <Row>
        <Col md={{size: 6, offset: 3}} style="margin-top: 20px;">
            <SelectToken
                    bind:selectedToken={$loginToken}
                    data-test-id="loginToken-select-token"
            />
        </Col>
    </Row>
    <Row style="margin-top: 20px;">
        <Col md={{size: 6, offset: 3}} style="text-align: right;">
            <Button
                    color="primary"
                    id="loginTokenLoginButton"
                    data-test-id="loginToken-button-login"
                    class={isValid ? "" : "invalid"}
                    title="Anmelden"
                    disabled={!isValid}
                    on:click={() => currentPage.set(LoginPin)}
            >
                Anmelden
            </Button>
        </Col>
    </Row>
</Container>

<ConfirmModal bind:showConfirm={showErrorWithRedirect} confirm={() => ($currentPage = LoginToken)}>
    {#snippet header()}
        <Fa icon={faTriangleExclamation}/>{errorTitle}
    {/snippet}

    {errorMessage}
</ConfirmModal>
